import React from "react";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { styled } from "@mui/material";
import TextInput from "./TextInput";

const StyledTextField = styled(TextInput)(() => ({
  width: "80px",
  "& .MuiInput-input": {
    padding: "5px 0px",
  },
  "& .MuiInputBase-root": {
    height: "100%",
    "& .MuiIconButton-root": { display: "none" },
  },
}));
interface DatePickerInterface {
  onChange: (value: any, keyboardInputValue?: string | undefined) => void;
  value: any;
  placeholder?: string;
}
const CustomDatePicker = ({
  onChange,
  value,
  placeholder,
}: DatePickerInterface) => {
  const [open, setOpen] = React.useState(false);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        views={["day", "month", "year"]}
        value={value}
        onChange={onChange}
        renderInput={(props) => (
          <StyledTextField
            onClick={() => setOpen(true)}
            autoComplete="off"
            size="small"
            {...props}
            inputProps={{
              ...props.inputProps,
              placeholder,
              style: { textAlign: "center" },
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};
export default CustomDatePicker;
